
  
  import TiwiMixin from '../mixins/TiwiMixin';
  import { h, compile } from 'vue';
  
  export default {
    mixins: [TiwiMixin],
  
    props: {
      content: {
        required: true,
        type: String,
      },
      
     
    },
    render() {
        return h({render: compile(this.content)})
    }
  
  }
  